export default __webpack_public_path__ + "static/media/competitiveness.2399dc22.png";